import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSchemaViewerNumberContinuous = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={17}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      style={{
        fill: "#47a67f",
      }}
      d="M16.5 9H14V7h2.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H14V3.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5V6h-2V3.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5V6H7.5c-.3 0-.5.2-.5.5s.2.5.5.5H10v2H7.5c-.3 0-.5.2-.5.5s.2.5.5.5H10v2.5c0 .3.2.5.5.5s.5-.2.5-.5V10h2v2.5c0 .3.2.5.5.5s.5-.2.5-.5V10h2.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM11 9V7h2v2h-2z"
    />
  </svg>
);
const Memo = memo(SvgSchemaViewerNumberContinuous);
export default Memo;
